import { TabPanel } from '@chakra-ui/react';

const Resource: React.FC = () => <TabPanel>{null}</TabPanel>;

export default Resource;
